export default __webpack_public_path__ + "images/purple-milky-way.svg";